import React, { Suspense } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { SEO as Seo } from "@/components/seo/SEO";
import { CalculatorsHeader } from "@/components/calculators/CalculatorsHeader";
import { DashboardLayout } from "@/components/layout/DashboardLayout";
import { RootLayout } from "@/components/layout/RootLayout";
import { isPublicCalculatorSlug } from "@/lib/calculatorSeo";
import { HOME_PAGE_SEO_KEYWORDS } from "@/lib/seoConfig";

const CALCULATORS_HUB_TITLE = "Free Financial Calculators for India | TellerWand";
const CALCULATORS_HUB_DESCRIPTION =
  "Free PPF, SIP, EPF, income tax, home loan EMI, retirement, insurance, and emergency fund calculators — plus family wealth management tools for Indian households.";

/**
 * Public calculator hub — indexable at /calculators without login.
 * Legacy ?calc= query params redirect to slug-based public routes.
 */
const Calculators: React.FC = () => {
  const { user } = useAuth();
  const [searchParams] = useSearchParams();
  const calcParam = searchParams.get("calc") ?? "";

  if (calcParam && isPublicCalculatorSlug(calcParam)) {
    return <Navigate to={`/calculators/${calcParam}`} replace />;
  }

  const Layout = user ? DashboardLayout : RootLayout;

  return (
    <>
      <Seo
        title={CALCULATORS_HUB_TITLE}
        description={CALCULATORS_HUB_DESCRIPTION}
        keywords={HOME_PAGE_SEO_KEYWORDS}
        canonical="/calculators"
      />

      <Layout>
        <div className="container max-w-7xl mx-auto space-y-4 sm:space-y-6 py-3 sm:py-4 md:py-6 px-3 sm:px-4">
          <Suspense fallback={null}>
            <CalculatorsHeader activeCalculator="" />
          </Suspense>
        </div>
      </Layout>
    </>
  );
};

export default Calculators;
